import React from 'react'
import { CallbackOnPipe, Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-pipelines'
import {
  CloseModalOnPipe,
  ExecuteOperationForModelOnPipe,
  Form,
  OpenModalOnPipe,
  Operation,
  useValue
} from '@morningtrain/react-resources'
import * as Auth from '@morningtrain/react-auth'
import Modal from 'widgets/modals/Modal'
import { TextArea } from '@morningtrain/react-fields'
import { Translation } from '@morningtrain/react-translations'
import * as UI from 'ui'
import ShiftExchangeRefreshPipes from 'support/actions/shifts/ShiftExchangeRefreshPipes'

export default function BuyShift ({ slotId, isOnSale = false, fullWidth = true }) {
  const buyableExchangeId = useValue('buyable_exchange_id')

  const modalRef = React.useRef()

  const _resolve = React.useRef()
  const _reject = React.useRef()

  const handleOnSubmit = (data) => {
    if (_resolve.current !== null) {
      _resolve.current(data)
    }
  }

  const handleClose = (err) => {
    if (_reject.current !== null) {
      _reject.current(err)
    }
  }

  const handleOnPipe = (payload) => {
    return new Promise((resolve, reject) => {
      _resolve.current = data => {
        payload.data = data
        resolve(data)
      }
      _reject.current = (err) => {
        reject(err)
      }
    })
  }

  return (
    <Auth.CanUseModel permission='api.shifts.exchange.buy'>
      <Modal ref={modalRef} handleClose={handleClose}>
        <Operation namespace='api' resourceName='shifts.exchange' operationName='buy'>
          <Form onSubmit={handleOnSubmit} submitTo='buy'>
            <input type='hidden' name='exchange_id' value={buyableExchangeId} />
            <div className='space-y-4'>
              <UI.SecondaryHeading>
                <Translation name='shiftexchange.forms.buy.title' />
              </UI.SecondaryHeading>
              <TextArea name='optional_comment' />
              <UI.SubmitButton>
                {isOnSale
                  ? (
                    <Translation name='shiftexchange.actions.buy' />
                    )
                  : (
                    <Translation name='shiftexchange.actions.request' />
                    )}
              </UI.SubmitButton>
            </div>
          </Form>
        </Operation>
      </Modal>

      <Pipeline>
        <TriggerPipelineOnClick>
          <UI.Button className={fullWidth ? 'w-full' : ''}>
            {isOnSale
              ? (
                <Translation name='shiftexchange.actions.buy' />
                )
              : (
                <Translation name='shiftexchange.actions.request' />
                )}
          </UI.Button>
        </TriggerPipelineOnClick>
        <OpenModalOnPipe modalRef={modalRef} />
        <CallbackOnPipe callback={handleOnPipe} />
        <CloseModalOnPipe modalRef={modalRef} />
        <ShiftExchangeRefreshPipes slotId={slotId} />
      </Pipeline>
    </Auth.CanUseModel>
  )
}
